import type { StreetNumbersInputProps as StreetNumbersInputPropsDS } from '@gov-design-system-ce/react-form';
import { FormStreetNumber as FormStreetNumberDS } from '@gov-design-system-ce/react-form';
import { MessageWrapper } from '../MessageWrapper';

export type StreetNumbersInputProps = Omit<
	StreetNumbersInputPropsDS,
	'messageWrapper' | 'classNames'
>;

export const StreetNumbersInput = (props: StreetNumbersInputProps) => (
	<FormStreetNumberDS
		{...props}
		field={{ size: 'm', ...props.field }}
		controlGroup={{ color: 'neutral', ...props.controlGroup }}
		messageWrapper={MessageWrapper}
	/>
);
